module.exports = __webpack_public_path__ + "static/media/live-stream-w64.bfa84016.svg";